/**
 * API origin for browser requests.
 * Leave VITE_API_URL unset in production so calls stay on the page origin
 * (/api/...). Netlify's edge proxy and Firebase Hosting both forward that
 * prefix to the Gen2 `api` function. Set VITE_API_URL only for a non-same-origin
 * override (local tunnel or an explicit Cloud Functions URL).
 */
export function apiOrigin(): string {
  const raw = (import.meta.env.VITE_API_URL as string | undefined)?.trim() ?? '';
  return raw.replace(/\/$/, '');
}

/** Join origin + path (`/api/...`). Empty origin → same-origin relative path. */
export function apiUrl(path: string): string {
  const p = path.startsWith('/') ? path : `/${path}`;
  const origin = apiOrigin();
  return origin ? `${origin}${p}` : p;
}
